import { Pipe, PipeTransform } from '@angular/core';
import { MonitoringAlarm } from '../models/monitoring-alarm';

@Pipe({
  name: 'filterAlarmByCategory'
})
export class FilterAlarmByCategoryPipe implements PipeTransform {

  transform(alarms: MonitoringAlarm[], alarmCategories: any, selectedCategoryId: number, selectedAlarmList: MonitoringAlarm[]): MonitoringAlarm[] {
    let filteredAlarms:MonitoringAlarm[] = [];
    if (selectedCategoryId === 0) {
      filteredAlarms = alarms;
    } else {
      if (alarms) {
        const selectedCategory = alarmCategories.find(cat => cat.id === selectedCategoryId);
        if (selectedCategory.severity === undefined) {
          filteredAlarms = alarms.filter(alarm => alarm.acknowledged ===  selectedCategory.acknowledged);
        } else {
          filteredAlarms = alarms.filter(alarm => {
              return (!alarm.acknowledged && alarm.severity && alarm.severity === selectedCategory.severity);
          })
        }
      }
    }
    return selectedAlarmList && selectedAlarmList.length > 0 ? filteredAlarms.filter(alarm => selectedAlarmList[0].projectId === alarm.projectId && selectedAlarmList[0].trainId === alarm.trainId) : filteredAlarms;

  }

}
